// src/components/Purchases.js - 多语言版本
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { fetchOrders, toggleOrder } from '../store/orderSlice';
import Loading from './Loading';
import styles from '../styles/Purchases.module.css';

const Purchases = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { orders, status, error } = useSelector((state) => state.orders);
  const { isLoggedIn, user } = useSelector((state) => state.user);

  useEffect(() => {
    console.log('Purchases component mounted');
    console.log('Current state:', { isLoggedIn, user });
    if (isLoggedIn && user?.user_key) {
      console.log('Dispatching fetchOrders with user_key:', user.user_key);
      dispatch(fetchOrders(user.user_key));
    } else {
      console.log('Conditions not met for fetching orders:', { isLoggedIn, user_key: user?.user_key });
    }
  }, [dispatch, isLoggedIn, user]);

  const handleAfterSales = (orderNo) => {
    navigate('/account', { state: { orderNo } });
  };

  const formatDate = (dateStr) => {
    // 根据当前语言获取适当的日期格式
    const currentLang = i18n.language || 'en';
    // 基础语言代码 (zh, en 等)
    const baseLang = currentLang.split('-')[0];
    
    // 针对不同语言使用不同的日期格式
    let locale = 'en-US';
    if (baseLang === 'zh') {
      locale = currentLang.includes('HK') || currentLang.includes('TW') ? 'zh-HK' : 'zh-CN';
    }
    
    const date = new Date(dateStr);
    return date.toLocaleDateString(locale, { year: 'numeric', month: 'numeric', day: 'numeric' });
  };

  if (status === 'loading') {
    return <Loading />;
  }

  if (status === 'failed') {
    return <div className={styles.error}>{t('purchases.loadingError')}: {error}</div>;
  }

  return (
    <section className={styles.purchasesSection}>
      <div className={styles.container}>
        <div className={styles.purchasesContainer}>
          <div className={styles.purchasesContent}>
            <div className={styles.contentHeader}>
              <h2 className={styles.contentTitle}>
                <i className="fas fa-shopping-bag"></i>
                <span>{t('purchases.title')}</span>
              </h2>
            </div>
            <div className={styles.contentBody}>
              <div className={styles.orderList}>
                {orders.length === 0 ? (
                  <div className={styles.empty}>{t('purchases.noRecords')}</div>
                ) : (
                  orders.map(order => (
                    <div key={order.out_trade_no} className={styles.orderItem}>
                      <div
                        className={`${styles.orderHeader} ${order.expanded ? styles.active : ''}`}
                        onClick={() => dispatch(toggleOrder(order.out_trade_no))}
                      >
                        <div className={styles.orderInfoCell}>
                          <span className={styles.orderId}>
                            <i className="fas fa-file-invoice"></i>
                            {order.product_name}
                          </span>
                        </div>
                        <div className={styles.orderInfoCell}>
                          <span className={styles.orderDate}>{formatDate(order.created_at)}</span>
                        </div>
                        <div className={styles.orderInfoCell}>
                          <span className={styles.orderPrice}>
                            ¥{parseFloat(order.product_price_cny).toFixed(2)}
                          </span>
                        </div>
                        <i className={`fas fa-chevron-down ${styles.orderToggle}`} />
                      </div>
                      <div className={`${styles.orderDetails} ${order.expanded ? styles.active : ''}`}>
                        <div className={styles.orderInfo}>
                          <div className={styles.infoRow}>
                            <span className={styles.infoLabel}>{t('purchases.orderNumber')}:</span>
                            <span>{order.orderNo}</span>
                          </div>
                          <div className={styles.infoRow}>
                            <span className={styles.infoLabel}>{t('purchases.transactionNumber')}:</span>
                            <span>{order.out_trade_no}</span>
                          </div>
                          <div className={styles.infoRow}>
                            <span className={styles.infoLabel}>{t('purchases.paymentChannel')}:</span>
                            <span>{order.payment_channel}</span>
                          </div>
                          {/* <div className={styles.infoRow}>
                            <span className={styles.infoLabel}>{t('purchases.productId')}:</span>
                            <span>{order.product_id}</span>
                          </div> */}
                          {/* <div className={styles.infoRow}>
                            <span className={styles.infoLabel}>{t('purchases.userKey')}:</span>
                            <span>{order.user_key}</span>
                          </div> */}
                        </div>
                        <div className={styles.orderActions}>
                          <button
                            className={`${styles.btn} ${styles.btnSm} ${styles.btnOutline}`}
                            onClick={() => handleAfterSales(order.orderNo)}
                          >
                            {t('purchases.applyAfterSales')}
                          </button>
                          {/* <button className={`${styles.btn} ${styles.btnSm}`}>
                            {t('purchases.viewDetails')}
                          </button> */}
                        </div>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Purchases;